import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="working-partners">
              <h4>Working Partners</h4>
              <div className="partners-logos">
                <div className="partner-item">
                  <img src="/NUTECh.png" alt="NUTECh" className="partner-logo" />
                  <span className="partner-name">NUTECH</span>
                </div>
                <div className="partner-item">
                  <img src="/pakistan.png" alt="Pakistan" className="partner-logo" />
                  <span className="partner-name">Govt of Pakistan</span>
                </div>
                <div className="partner-item">
                  <img src="/punjab.svg" alt="Punjab" className="partner-logo" />
                  <span className="partner-name">Govt of Punjab</span>
                </div>
                <div className="partner-item">
                  <img src="/ptv.jpeg" alt="PTV" className="partner-logo" />
                  <span className="partner-name">PTV</span>
                </div>

                <div className="partner-item">
                  <img src="/mcom.png" alt="MCOM" className="partner-logo" />
                  <span className="partner-name">MCOM Pvt ltd</span>
                </div>
                <div className="partner-item">
                  <img src="/bhc.png" alt="BHC" className="partner-logo" />
                  <span className="partner-name">British High Comission</span>
                </div>
                <div className="partner-item">
                  <img src="/eu.jpeg" alt="EU" className="partner-logo" />
                  <span className="partner-name">EU </span>
                </div>
                <div className="partner-item">
                  <img src="/aantv.jpeg" alt="antv" className="partner-logo" />
                  <span className="partner-name">AAN TV </span>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-center">
            <img
              src="/logo.png"
              alt="Abbott Music Studio"
              className="footer-logo"
            />
            <p>
              &copy; 2026 Abbott Music Studio. ISO 9001-2015 Certified. All rights
              reserved.
            </p>
          </div>

          <div className="footer-right">
            <div className="social-links">
              <a
                href="https://www.instagram.com/abbott_music_studio/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/instagram.png" alt="Instagram" width="24" height="24" />
              </a>
              <a
                href="https://www.youtube.com/@abbottmusicstudio"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/youtube.png" alt="YouTube" width="24" height="24" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61559059985461"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/facebook.png" alt="Facebook" width="24" height="24" />
              </a>
              <a
                href="https://www.linkedin.com/in/muhammad-akmal-0655642b1/"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/linkedin.png" alt="LinkedIn" width="24" height="24" />
              </a>
            </div>
            <a
              href="https://github.com/SalarMohammadUzair"
              target="_blank"
              rel="noopener noreferrer"
              className="developer-tag"
            >
              Developed by Smbleh
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
